module.exports = __webpack_public_path__ + "static/media/checklist.43a64c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/get-started/checklist.png
// module id = 1530
// module chunks = 3